<template>
  <Dialog v-if="isActive" v-show="isActive" class="backdrop-blur-sm" :extend-class="['md:max-w-3xl mb-[2rem]']">
    <div class="bg-white rounded-lg w-full">
      <div class="p-8">
        <div class="flex justify-between items-center mb-6">
          <h2 class="text-3xl font-medium">Add qualification</h2>
          <img src="@/assets/icons/times.svg" class="w-4 cursor-pointer" alt="" @click="$emit('close')" />
        </div>

        <div class="grid grid-cols-1 gap-4 md:grid-cols-2 mb-4">
          <div>
            <Input type="text" v-model="qualification.school_name" label="College / University" placeholder="Your college / university name" />
          </div>

          <div>
            <Input type="text" v-model="qualification.country" label="Country" placeholder="Country name" />
          </div>

          <div>
            <label for="" class="block text-md font-albert text-brand-black/70 mb-2">Start Year</label>
            <VueDatePicker year-picker v-model="qualification.start_date"></VueDatePicker>
          </div>

          <div>
            <label for="" class="block text-md font-albert text-brand-black/70 mb-2">End Year</label>
            <VueDatePicker year-picker v-model="qualification.end_date"></VueDatePicker>
          </div>

          <div>
            <Input type="text" label="Degree title" placeholder="e.g Masters in Computer Science" v-model="qualification.degree_type" />
          </div>
        </div>

        <div class="mb-6">
          <Input type="textarea" v-model="qualification.education_details" label="Description" placeholder="Select" />
        </div>

        <div class="flex justify-end">
          <Button data-test="login-button" label="Save" color="primary" type="button" class="px-8 rounded-xl" @click="$emit('confirm')" />
        </div>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
import Dialog from '@/components/Dialog.vue';
import { onMounted } from 'vue';
import Input from '../form/Input.vue';
import Button from '../Button.vue';

const props = defineProps({
  isActive: { type: Boolean, default: false },
  qualification: { type: Object },
});

onMounted(() => {});
</script>
